












import Vue from 'vue';
import type { PropOptions } from 'vue';
import type { Notification, Testimonial } from '@/types/graphql';
import TestimonialIcon from './images/testimonial-icon.vue.svg';
import HeaderMenuNotificationsCardGrid from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import HeaderMenuNotificationsCardGridAvatar from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardTestimonial',
  components: {
    TestimonialIcon,
    HeaderMenuNotificationsCardGridAvatar,
    HeaderMenuNotificationsCardGrid,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
  computed: {
    referenceable(): Testimonial {
      return this.notification.referenceable as Testimonial;
    },
    authorName(): string {
      const author = this.referenceable.author;
      return `${author.firstname || ''} ${author.lastname || ''}`;
    },
  },
});
